export const P2_LIKE_ROLES = new Set(["p2", "p4"]);

export const isP2LikeRole = (role) => {
  return typeof role === "string" && P2_LIKE_ROLES.has(role);
};

export const isPatientOrP2LikeRole = (role) => {
  return role === "patient" || isP2LikeRole(role);
};
